<script lang="ts" setup>
	defineProps<{
		label?: string
	}>()
</script>

<template>
	<div>
		<div
			class="default-btn w-full justify-center rounded !border-none bg-success-50 font-semibold text-gray-800 sm:text-2xl"
		>
			<slot>{{ label }}</slot>
		</div>
	</div>
</template>
